import angular from 'angular';
import cessationModal from './cessationModal';

export default angular
  .module('components.cessationModal', [])
  .component('cessationModal', cessationModal).name;
